import Vue from "vue";
import Vuex from "vuex";
import cookie from "vue-cookie";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    cookie: cookie.get("cookie"),
    refresh_cookie: cookie.get("refresh_cookie"),
    request_opened: 0,
    alert_visible: false,
    alert_message: "",
    alert_color: "primary",
    alert_type: "success",
    auth: cookie.get("cookie_type"),
    user: JSON.parse(localStorage.getItem("user")) || {},
    publicRoutes: [],
  },

  actions: {
    logoff(context) {
      localStorage.getItem("loginContext");
      
      if (localStorage.getItem("loginContext") === "cas")
        localStorage.setItem("casLoginContext", "true");

      return new Promise((resolve, reject) => {
        try {
          context.commit("logoff");
          let path = '/';
          if(process.env.VUE_APP_PUBLIC_PATH !== undefined){
            path += process.env.VUE_APP_PUBLIC_PATH+'/';
          }
          if(process.env.VUE_APP_LOGIN_LOCAL_PATH !== undefined){
            path += process.env.VUE_APP_LOGIN_LOCAL_PATH;
          }
          path = (path.replace(/\/\//g, '/')).replace(/^\//, '');          
          window.location.replace(path);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    login(context, data) {
      return new Promise((resolve, reject) => {
        try {
          context.commit("login", {
            auth: data.token_type,
            token: data.access_token,
            refresh_token: data.refresh_token,
          });
          context.commit("user", data.user);

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  mutations: {
    openConection(state) {
      state.request_opened += 1;
    },

    closeConection(state) {
      state.request_opened -= 1;
    },

    set_message(state, { message, color, type }) {
      state.alert_visible = !state.alert_visible;
      state.alert_message = message;
      state.alert_color = color;
      state.alert_type = type;
    },

    login(state, objs) {
      const cookie_options = {
        secure: true,
        sameSite: "Lax",
      };

      cookie.set("cookie", encodeURI(window.btoa(objs.token)), cookie_options);
      cookie.set("refresh_cookie", encodeURI(window.btoa(objs.refresh_token)), cookie_options);
      cookie.set("cookie_type", window.btoa(objs.auth), cookie_options);

      state.refresh_cookie = encodeURI(window.btoa(objs.refresh_token));
      state.cookie = encodeURI(window.btoa(objs.token));
      state.auth = window.btoa(objs.auth);
    },

    logoff(state) {
      try {
        state.refresh_cookie = null;
        state.cookie = null;
        state.auth = null;
        state.user = null;
        localStorage.removeItem("user");
        cookie.delete("cookie");
        cookie.delete("cookie_type");
        cookie.delete("cookie_refresh");
      } catch (error) {
        console.log(error);
      }
    },

    user(state, json_user) {
      state.user = json_user;
      localStorage.setItem("user", JSON.stringify(json_user));
    },

    publicRoutes(state, routes) {
      state.publicRoutes = [...routes];
    },
  },

  getters: {
    isAuthenticated: (state) => !!state.cookie,

    logged: (state) => !!state.cookie,

    token: (state) => {
      if (state.auth && state.cookie) {
        let type_auth = window.atob(decodeURI(state.auth));
        let token_auth = window.atob(state.cookie);
        return type_auth + " " + token_auth;
      } else {
        return null;
      }
    },

    refresh_token: (state) => window.atob(state.refresh_cookie),

    user_name: (state) => state.user.name,

    user: (state) => state.user,

    publicRoutes: (state) => state.publicRoutes,
  },
});
